import Swiper, {Pagination, Grid, FreeMode} from "swiper";

export default (el) => {
  const bestSellingEl = el.querySelector('.js-home-best-selling')

  new Swiper(bestSellingEl, {
    modules: [Pagination, Grid, FreeMode],
    slidesPerView: 1.2,
    spaceBetween: 12,
    freeMode: {
      enabled: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3.4,
      },
      992: {
        slidesPerView: 4.4,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: false,
        grid: {
          rows: 2,
          fill: 'row',
        },
      }
    },
  })
}
